import getBookingPax from './getBookingPax';

const getAdditionalCustomers = (state, bookingReference) =>
  getBookingPax(state, bookingReference)
    .map(({ customer_id }) => parseInt(customer_id, 10))
    .map(customerId => state.customer.additionalCustomers[customerId])
    .filter(customer => customer);

export default getAdditionalCustomers;
